import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { FiltersOnDesktop } from './filters/filters-on-desktop';
import { FiltersOnMobile } from './filters/filters-on-mobile';

export const Filters = () => {
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.max });

  if (isMobile) {
    return <FiltersOnMobile />;
  }

  return <FiltersOnDesktop />;
};
